export function getReferrer(): string {
  return document.referrer;
}

type SessionWindow = typeof window & { hubspot: { sessionId: string | null } };

export function getSessionId(): string | null | undefined {
  return window.hubspot && (window as SessionWindow).hubspot.sessionId;
}
